import { useMutation } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { OrgTableUpdateItem } from 'types'

export const batchUpdateItems = async (updates: OrgTableUpdateItem[]) => {
  const response = await axios.put(`${baseUrl}/aws/organizations_table/batchupdateitems`, { updates })
  return response.data
}

export const useBatchUpdateItems = () => {
  return useMutation({
    mutationFn: (updates: OrgTableUpdateItem[]) => batchUpdateItems(updates),
    onSuccess: () => {
      console.log('[useBatchUpdateItems] ✅ Batch update success')
      // NOTE: Cache sync is handled by the calling hook (useMassUpdate, useMassUpdateOrganizations, etc.)
      // Do NOT invalidateQueries here - it would refetch stale server data and overwrite optimistic updates
    },
    onError: error => {
      console.error('[useBatchUpdateItems] ❌ Batch update failed', error)
    },
  })
}
